export const MEDIA_PACK = {
  EDIT_MODAL_ID: 'editModalId',
};
